import Icon from '@plone/volto/components/theme/Icon/Icon';
import cx from 'classnames';
import { defineMessages, injectIntl } from 'react-intl';

import styles from './FlipButton.module.less';

import flipcard from 'govbr.frontend.policy/icons/flip-card.svg';

const messages = defineMessages({
  showDescription: {
    id: 'Show description',
    defaultMessage: 'Show description',
  },
});

const FlipButton = ({ intl, onClick, background = 'gray', className }) => {
  const classes = cx(styles[background], { [className]: className });

  return (
    <div className={classes}>
      <button
        onClick={onClick}
        className={`br-button circle small ${styles.btn}`}
        title={intl.formatMessage(messages.showDescription)}
      >
        <Icon name={flipcard} className="" size="18px" />
      </button>
    </div>
  );
};

export default injectIntl(FlipButton);
